import styled from "styled-components"
import { device } from "../../utils/breakpoints.js"

export const InternalHeaderContainer = styled.div`
  padding-top: 316px;
  background: #d8d8d8;
  margin: 0 auto;
  width: 100%;
  z-index: -1;
  max-width: 1660px;
  position: relative;
  @media ${device.desktop} {
    padding-top: 283px;
  }

  h1 {
    font-size: 32px;
    color: white;
    font-weight: 500;
    @media ${device.desktop} {
      font-size: 55px;
    }

    @media ${device.large} {
      font-size: 64px;
    }
  }

  .avenueImg {
    position: absolute !important;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
  }
`

export const TitleWrapper = styled.div`
  width:100%;
  background:#10523D;
  z-index:2;
  padding:22px 40px;
  /* @media ${device.tablet} {
    width: ${props => `calc(100% - 2*${props.theme.tabletGutter}px)`};
  } */
  @media ${device.desktop} {
  padding:26px 40px;

  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: ${props => `${props.theme.mainMaxWidth}px`};
  width: ${props => `calc(100% - 2*${props.theme.desktopGutter}px)`};
  height:
  }
`
